interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Simple line-style bar-chart glyph for "no data to show" empty states. */
const NoChartDataIcon = ({ width = 48, height = 48, color = '#C4CBD6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='6' y='26' width='8' height='16' rx='2' stroke={color} strokeWidth='2.5' />
      <rect x='20' y='16' width='8' height='26' rx='2' stroke={color} strokeWidth='2.5' />
      <rect x='34' y='8' width='8' height='34' rx='2' stroke={color} strokeWidth='2.5' />
    </svg>
  );
};

export default NoChartDataIcon;
